<template>
  <div class="oder_management">
    <div ref="tablePanel" class="fullheight">
      <div class="top_search">
        <el-row style="height: 100%; width: 100%">
          <el-col :span="6"><el-button type="primary" @click="showAddTemp()" size="small">添加套餐</el-button></el-col>
          <el-col :span="6" class="col_style" :offset="12">
            <el-input v-model="code" placeholder="请输入套餐名称搜索" @keyup.enter.native="loadData()"
              suffix-icon="el-icon-search"
            >
              <!-- <el-button slot="append" type="primary" @click="loadData()">搜索</el-button> -->
            </el-input>
          </el-col>
        </el-row>
      </div>
      <div class="table_content">
        <el-table
          ref="ecoTable"
          :style="{
            height: `${tableMaxHeight}` + 'px'
          }"
          :max-height="tableMaxHeight"
          :data="templateData"
          tooltip-effect="dark"
          style="width: 100%"
          border
          :header-cell-style="headerCellStyle"
        >
          <el-table-column type="index" label="序号" width="55"> </el-table-column>
          <el-table-column prop="charge_type" label="收费类型" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ $utils.findAllDataDict(scope.row.charge_type, 'sflx', allDataDict) }}
            </template>
          </el-table-column>
          <el-table-column prop="third_combo_account_relation" label="关联产品"> </el-table-column>
          <el-table-column prop="combo_name" label="套餐名称"> </el-table-column>
          <el-table-column prop="price" label="套餐价格">
            <template slot-scope="scope">
              {{ $utils.thousandBit(scope.row.price) }}
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间"> </el-table-column>
          <el-table-column prop="name" label="操作">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="temModify(scope.row.id)" style="margin-right: 16px">编辑</el-link
              ><el-link type="primary" :underline="false" @click="temDel(scope.row.id)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="page_bean">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 40, 50, 100, 500]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
      <!--模板添加-->
      <package-center-add :dialogVisible="taVisible" @beforeClose="beforeTaClose"></package-center-add>
      <!--模板编辑-->
      <package-center-modify :dialogVisible="tmVisible" :selectModel="selectModel" @beforeClose="beforeTmClose"></package-center-modify>
    </div>
  </div>
</template>

<script>
import form from '@/api/form'
import * as constants from './htmb/constants'
const packageCenterAdd = () => import('@/views/form/packageCenter/packageCenterAdd.vue')
const packageCenterModify = () => import('@/views/form/packageCenter/packageCenterModify.vue')
import { mapState } from 'vuex'
export default {
  components: {
    packageCenterAdd,
    packageCenterModify
  },
  data() {
    return {
      total: 0,
      pageSize: 20,
      currentPage: 1,
      templateData: [],
      boDefIdList: [],
      selectUploadId: null,
      selectModel: null,
      taVisible: false,
      tmVisible: false,
      ...constants,
      tableMaxHeight: document.body.clientHeight - 220,
      activeName: 'first',
      code: ''
    }
  },
  mounted() {
    this.loadData()
    this.calcTableHeight()
    this.$root.$on('resize', () => {
      this.calcTableHeight(500)
      this.$nextTick(() => {
        this.$refs.ecoTable.doLayout()
      })
    })
    this.tenantId = this.$store.state.login.currentUser.tenantId
  },
  computed: {
    ...mapState({
      allDataDict: (state) => state.user.allDataDict
    })
  },
  methods: {
    //表头样式
    headerCellStyle() {
      return {
        backgroundColor: '#F3F3F3',
        color: '#333333'
      }
    },
    //每页数量调整
    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },
    //页数跳转
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadData()
    },
    // 动态计算表格的高度，自适应当前容器
    calcTableHeight(delay) {
      setTimeout(() => {
        if (!this.$refs.tablePanel) {
          return
        }
        const tablePanelHeight = this.$refs.tablePanel.$el.clientHeight
        this.tableMaxHeight = tablePanelHeight - 220
      }, delay || 0)
    },
    handleClick(tab, event) {
      console.log(tab, event)
    },
    // 获取收费类型树结构
    getSflxTree() {
      let params = {
        typeKey: 'sflx'
      }
      form.getByTypeKeyForComBo(params).then((resp) => {
        this.boDefIdList = resp
      })
    },
    //初始化加载
    loadData(prop, sort) {
      let params = {
        pageBean: {
          page: this.currentPage,
          pageSize: this.pageSize,
          total: 0
        }
      }
      if (this.code) {
        params.querys = []
        if (this.code) {
          params.querys.push({
            group: 'advance',
            value: this.code,
            relation: 'AND',
            operation: 'LIKE',
            property: 'F_combo_name'
          })
        }
      }
      if (prop) {
        params.sorter = [{ property: prop, direction: sort }]
      }
      form
        .getPackageCenterList(params)
        .then((resp) => {
          this.templateData = resp.rows
          this.total = resp.total
        })
        .finally(() => {
          if (cb) {
            cb()
          }
        })
    },
    // 删除
    temDel(id) {
      let params = {
        id: id
      }
      form.getDelThirdCombo(params).then((resp) => {
        if (resp.state) {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.loadData(this.pageBean)
        }
      })
    },
    // 展示添加模板
    showAddTemp() {
      this.taVisible = true
    },
    temModify(id) {
      this.selectModel = id
      this.tmVisible = true
    },
    // 关闭temp上传
    beforeTaClose() {
      this.selectModel = null
      this.taVisible = false
      this.loadData()
    },
    // 关闭temp上传
    beforeTmClose() {
      this.selectModel = null
      this.tmVisible = false
      this.loadData()
    }
  }
}
</script>

<style scoped>
.oder_management {
  height: calc(100% - 20px);
  padding-top: 10px;
}
.top_search {
  height: 45px;
  width: 100%;
  display: flex;
  align-items: center;
}
.col_style {
  height: 100%;
  display: flex;
  align-items: center;
}
/deep/.el-input-group__append button.el-button {
  border-color: transparent;
  background-color: #377cff;
  color: white;
  border-top: 0;
  border-bottom: 0;
}
.button_group {
  height: 40px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.page_bean {
  display: flex;
  justify-content: right;
  align-items: center;
}
/deep/.el-tabs__item.is-active {
  color: #fff !important;
  border: 0;
  border-radius: 5px;
  background: url(../../assets/img/tabBg.png) no-repeat center;
  background-size: 98% 40px;
}
/deep/.el-tabs__active-bar {
  background-color: #fff;
}
/deep/.el-tabs__nav-wrap::after {
  background-color: #fff;
}
/deep/.el-tabs__item {
  padding: 5px 15px !important;
  color: #101010 !important;
  line-height: normal !important;
}
/deep/.el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0px 0px 5px 0px;
}
</style>
